import styled from "styled-components";

const ProductTypePageStyled = styled.div`

`;

export default ProductTypePageStyled;